import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import ThankYouPage from './components/ThankYouPage';
import WishesPage from './components/WishesPage';
import Loading from './components/Loading';
import './styles/App.scss';
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);
  if (loading) {
    return <Loading />;
  }
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/wishes" element={<WishesPage />} />
        </Routes>
      </div>
    </Router>
  );
}
export default App;